import { render, staticRenderFns } from "./FeedBackPage.vue?vue&type=template&id=5942ea3a&"
import script from "./FeedBackPage.vue?vue&type=script&lang=js&"
export * from "./FeedBackPage.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports